module.exports = __webpack_public_path__ + "img/avatar_ico1.46fd6404.jpg";